module.exports = __webpack_public_path__ + "static/media/20ECE29.065eb47b.jpg";